<template>
  <div class="public-filter">
    <form @submit.prevent>
      <h1>Keyword Search</h1>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          id="keyword_search"
          v-model="search_string"
          @keyup.enter="updateQuery"
        />
      </div>
      <div class="button-group">
        <button type="button" class="btn btn-primary" @click="updateQuery">Search</button>
        <button type="button" class="btn btn-primary" @click="refreshFilters">Clear filters</button>
      </div>
      <br />
    </form>
    <form>
      <h1>Certificate Type</h1>
      <div class="form-group" @click="clearProductType">
        <label for="modbus-checkbox">
          <input
            type="checkbox"
            id="modbus-checkbox"
            true-value="SunSpec%20Modbus"
            false-value=""
            v-model="query_data.CertificateType"
          /> SunSpec Modbus
        </label>
        <label for="1547-checkbox">
          <input
            type="checkbox"
            id="1547-checkbox"
            true-value="SunSpec%20Modbus%20IEEE%201547"
            false-value=""
            v-model="query_data.CertificateType"
          /> SunSpec Modbus IEEE 1547
        </label>
        <label for="CSIP-checkbox">
          <input
            type="checkbox"
            id="CSIP-checkbox"
            true-value="2030.5%20CSIP"
            false-value=""
            v-model="query_data.CertificateType"
          /> 2030.5 CSIP
        </label>
        <label for="sunspec-rsd-checkbox">
          <input
            type="checkbox"
            id="sunspec-rsd-checkbox"
            true-value="SunSpec%20Rapid%20Shutdown"
            false-value=""
            v-model="query_data.CertificateType"
          /> SunSpec Rapid Shutdown
        </label>
      </div>
      <!-- <h1>Sub Type</h1>
      <div class="modbus 1547 product form-group" v-show="query_data.CertificateType == 'SunSpec%20Modbus' || query_data.CertificateType == 'SunSpec%20Modbus%20IEEE%201547'">
        <label for="inverter-checkbox">
          <input
            type="checkbox"
            id="inverter-checkbox"
            value="Inverter"
            v-model="query_data.ProductType"
          /> Inverter
        </label>
      </div>
      <div class="1547 product form-group" v-show="query_data.CertificateType == 'SunSpec%20Modbus%20IEEE%201547'">
        <label for="energy-storage-system-checkbox">
          <input
            type="checkbox"
            id="energy-storage-system-checkbox"
            value="Energy%20Storage%20System"
            v-model="query_data.ProductType"
          /> Energy Storage System
        </label>
      </div>
      <div class="rapidShutdown product form-group" v-show="query_data.CertificateType == 'SunSpec%20Rapid%20Shutdown'">
        <label for="transmitter-checkbox">
          <input
            type="checkbox"
            id="transmitter-checkbox"
            value="Transmitter"
            v-model="query_data.ProductType"
          /> Transmitter
        </label>
        <label for="reciever-checkbox">
          <input
            type="checkbox"
            id="reciever-checkbox"
            value="Receiver"
            v-model="query_data.ProductType"
          /> Receiver
        </label>
      </div>
      <div class="csip product form-group" v-show="query_data.CertificateType == '2030.5%20CSIP'">
        <label for="client-checkbox">
          <input
            type="checkbox"
            id="client-checkbox"
            value="Client"
            v-model="query_data.ProductType"
          /> Client
        </label>
        <label for="server-checkbox">
          <input
            type="checkbox"
            id="server-checkbox"
            value="Server"
            v-model="query_data.ProductType"
          /> Server
        </label>
        <label for="aggregator-checkbox">
          <input
            type="checkbox"
            id="aggregator-checkbox"
            value="Aggregator"
            v-model="query_data.ProductType"
          /> Aggregator
        </label>
      </div>
      <div class="modbus product form-group" v-show="query_data.CertificateType == 'SunSpec%20Modbus'">
        <label for="battery-checkbox">
          <input
            type="checkbox"
            id="battery-checkbox"
            value="Battery"
            v-model="query_data.ProductType"
          /> Battery
        </label>
        <label for="data-logger-checkbox">
          <input
            type="checkbox"
            id="data-logger-checkbox"
            value="Gateway"
            v-model="query_data.ProductType"
          /> Gateway
        </label>
        <label for="meter-checkbox">
          <input
            type="checkbox"
            id="meter-checkbox"
            value="Meter"
            v-model="query_data.ProductType"
          /> Meter
        </label>
        <label for="PV-Module">
          <input 
            type="checkbox"
            id="controller-checkbox"
            value="Controller"
            v-model="query_data.ProductType"
          /> Controller
        </label>
        <label for="string-combiner-checkbox">
          <input
            type="checkbox"
            id="string-combiner-checkbox"
            value="SUB-COMPONENTS"
            v-model="query_data.ProductType"
          /> String Combiner
        </label>
        <label for="tracker-checkbox">
          <input
            type="checkbox"
            id="tracker-checkbox"
            value="Tracker"
            v-model="query_data.ProductType"
          /> Tracker
        </label>
        <label for="environmental-checkbox">
          <input
            type="checkbox"
            id="environmental-checkbox"
            value="Environmental"
            v-model="query_data.ProductType"
          /> Environmental
        </label>
        <label for="other-checkbox">
          <input
            type="checkbox"
            id="other-checkbox"
            value="Other"
            v-model="query_data.ProductType"
          /> Other
        </label>
      </div> -->
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query_data: {
        ProductType: [],
        CertificateType: ""
      },
      search_string: ""
    };
  },
  methods: {
    updateQuery() {
      this.$store.commit("toggleAPILoading");
      // console.log(this.query_data);
      let query_search_string = "";
      if (this.search_string) {
        query_search_string = "search=" + this.search_string;
      }

      let query_string = "?";

      Object.keys(this.query_data).forEach(key => {
        if (this.query_data[key].length != 0) {
          if (query_string == "?") {
            query_string += key + "__in=";
          } else {
            query_string += "&" + key + "__in=";
          }
          if (key == 'ProductType') {
            for (let i in this.query_data[key]) {
              query_string += this.query_data[key][i] + ",";
              if (this.query_data[key][i] == 'Other') {
                query_string += "Application, Weather%20Station,"
              }
            }
            query_string = query_string.slice(0, -1);            
          } else {
            query_string += this.query_data[key]
          }
        }
      });

      if (query_string == "?") {
        query_string = query_string + query_search_string;
      } else {
        query_string = query_string + "&" + query_search_string;
      }
      // console.log("ProductType: " + this.query_data.ProductType);
      // console.log("CertificateType: " + this.query_data.CertificateType);
      console.log(query_string);
      this.$store.commit("callAPI", query_string);
    },
    refreshFilters() {
      this.$store.commit("toggleAPILoading");

      this.search_string = "";
      this.query_data.ProductType = [];
      this.query_data.CertificateType = "";
      this.$store.commit("clearQueryString");
      this.$store.commit("callAPI");
    },
    clearProductType() {
      this.query_data.ProductType = [];
    },
    updateSearch() {
      this.$store.commit("toggleAPILoading");

      let query_search_string = "?search=" + this.search_string;
      // console.log(query_search_string);
      this.$store.commit("callAPI", query_search_string);
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 22px;
  background-color: #e66026;
  color: white;
  padding-left: 10px;
  font-family: "Electrolize", Helvetica, Arial, Lucida, sans-serif;
  font-weight: bold;
  padding-top: 8px;
  padding-bottom: 8px;
}

.public-filter {
  height: 100%;
  border-color: #444549;
  border-style: solid;
  border-width: 2px;
  max-height: 900px;
  background-color: white;
}

.form-group{
  font-family: "Montserrat";
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 0px;
  display: block;
}

button {
  margin: 0 15px 0 15px;
}

label {
  display: block;
}

.button-group {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.btn-primary:active,
.btn-primary:focus,
.btn-primary,
.btn-primary:visited,
.btn-primary:disabled {
  background-color: #1d4679;
  border-color: #1d4679;
}

.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}

label {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>


<!-- v2 styling 

<style scoped>
h1 {
  font-size: 22px;
  background-color: #00448b;
  color: white;
  padding-left: 10px;
}

.public-filter {
  height: 100%;
  border-color: #00448b;
  border-style: solid;
  border-width: 2px;
  max-height: 800px;
  background-color: white;
}

.form-group {
  padding-left: 10px;
  padding-right: 10px;
  display: block;
}

button {
  margin: 0 15px 0 15px;
}

label {
  display: block;
}

.button-group {
  display: flex;
  justify-content: center;
}

/* .btn-primary,
.btn-primary:hover,
.btn-primary:active,
.btn-primary:visited {
  background-color: #8064a2 !important;
} */
</style>

-->


<!--

old black style


h1 {
  font-size: 22px;
  background-color: black;
  color: white;
  padding-left: 10px;
}

.public-filter {
  height: 100%;
  border-style: solid;
  border-width: 2px;
  max-height: 800px;
  background-color: white;
}

.form-group {
  padding-left: 10px;
  padding-right: 10px;
  display: block;
}

button {
  margin: 0 15px 0 15px;
}

label {
  display: block;
}

.button-group {
  display: flex;
  justify-content: center;
}

-->
